var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import store from "../../../../store";
import { AIF_PMS_APPLY_SORT, AIF_PMS_CLEAR_MSG, AIF_PMS_CLEAR_SEARCH_DATA, AIF_PMS_CLEAR_SORT, AIF_PMS_ERROR, AIF_PMS_HIDE_ERROR, AIF_PMS_PARAMS, AIF_PMS_STOP_LOADER, AIF_PMS_TABLE_STOP_LOADER, AIF_PMS_UPDATE, AIF_PMS_UPDATE_MSG, AIF_PMS_UPDATE_SEARCH_DATA, AIF_PMS_UPDATE_SORTED_DATA, IF_PMS_VALIDATE_FORM_NUMBER, AIF_PMS_RECENT_CLIENT_SEARCH_DATA, AIF_PMS_PRODUCT_DETAILS_DATA, AIF_PMS_FILTER_DETAILS_DATA_AMC, AIF_PMS_FILTER_DETAILS_DATA_FUND, AIF_PMS_TABLE_START_LOADER, UPDATE_WATCHLIST_DATA, UPDATE_BOOKMARK_WATCHLIST, UPDATE_SUB_CATEGORY_ID, UPDATE_CLIENT_DETAILS, AIF_PMS_PRODUCT_DOWNLOAD_DATA, UPDATE_MULTI_BOOKMARK, UPDATE_TRANS_ID, UPDATE_DELTED_DRAFT_DOCS, UPDATE_SAVE_DRAFT_DOCS, AIF_PMS_FILTER_DETAILS_DATA_CATEGORY, AIF_PMS_ORDER_DATA, AIF_PMS_FILTER_LIST_DATA_FUND_NAME, AIF_PMS_FILTER_LIST_DATA_Tenure, AIF_PMS_FILTER_LIST_DATA_Benchmark, AIF_PMS_FILTER_LIST_DATA_AIF_FUND_NAME, UPDATE_COMMON_BANK_MASTER, AIF_PMS_FILTER_DETAILS_FUND_NAME, UPDATE_SUB_CATEGORY_PMS_ID, } from "../interface";
var AifPmsActions = /** @class */ (function () {
    function AifPmsActions() {
        this.dispatch = store.dispatch;
    }
    AifPmsActions.prototype.getFilterListAIFFundName = function (data) {
        this.dispatch({
            type: AIF_PMS_FILTER_LIST_DATA_AIF_FUND_NAME,
            payload: { filterListAIFFundName: data },
        });
    };
    AifPmsActions.prototype.getFilterListFundName = function (data) {
        this.dispatch({
            type: AIF_PMS_FILTER_LIST_DATA_FUND_NAME,
            payload: { filterListFundName: data },
        });
    };
    AifPmsActions.prototype.getFilterListTenure = function (data) {
        this.dispatch({
            type: AIF_PMS_FILTER_LIST_DATA_Tenure,
            payload: { filterListTenure: data },
        });
    };
    AifPmsActions.prototype.getFilterListBenchmark = function (data) {
        this.dispatch({
            type: AIF_PMS_FILTER_LIST_DATA_Benchmark,
            payload: { filterListBenchmark: data },
        });
    };
    AifPmsActions.prototype.ordersData = function (response) {
        this.dispatch({
            type: AIF_PMS_ORDER_DATA,
            payload: response,
        });
    };
    AifPmsActions.prototype.downloadProductFile = function (req) {
        this.dispatch({
            type: AIF_PMS_PRODUCT_DOWNLOAD_DATA,
            payload: req,
        });
    };
    AifPmsActions.prototype.getFilterDetailsAmc = function (data) {
        this.dispatch({
            type: AIF_PMS_FILTER_DETAILS_DATA_AMC,
            payload: { filterDetailsAmc: data },
        });
    };
    AifPmsActions.prototype.getFilterDetailsCategory = function (data) {
        this.dispatch({
            type: AIF_PMS_FILTER_DETAILS_DATA_CATEGORY,
            payload: { filterDetailsCategory: data },
        });
    };
    AifPmsActions.prototype.getFilterDetailsFund = function (data) {
        this.dispatch({
            type: AIF_PMS_FILTER_DETAILS_DATA_FUND,
            payload: { filterDetailsFund: data },
        });
    };
    AifPmsActions.prototype.getFilterDetailFundName = function (data) {
        this.dispatch({
            type: AIF_PMS_FILTER_DETAILS_FUND_NAME,
            payload: { filterDetailsFundName: data },
        });
    };
    AifPmsActions.prototype.getProductDetails = function (requestPayload) {
        this.dispatch({
            type: AIF_PMS_PRODUCT_DETAILS_DATA,
            payload: { productDetails: __assign({}, requestPayload) },
        });
    };
    AifPmsActions.prototype.getRecentClientSearchList = function (requestPayload) {
        this.dispatch({
            type: AIF_PMS_RECENT_CLIENT_SEARCH_DATA,
            payload: requestPayload,
        });
    };
    AifPmsActions.prototype.getValidateFormNumber = function (validateFormNumber) {
        this.dispatch({
            type: IF_PMS_VALIDATE_FORM_NUMBER,
            payload: validateFormNumber,
        });
    };
    AifPmsActions.prototype.startAifPmsLoader = function () {
        this.dispatch({
            type: AIF_PMS_STOP_LOADER,
        });
    };
    AifPmsActions.prototype.startAifPmsTableLoader = function () {
        this.dispatch({
            type: AIF_PMS_TABLE_START_LOADER,
        });
    };
    AifPmsActions.prototype.stopAifPmsLoader = function () {
        this.dispatch({
            type: AIF_PMS_STOP_LOADER,
        });
    };
    AifPmsActions.prototype.stopAifPmsTableLoader = function () {
        this.dispatch({
            type: AIF_PMS_TABLE_STOP_LOADER,
        });
    };
    AifPmsActions.prototype.getAifPmsWatchList = function (data, update, totalPages) {
        this.dispatch({
            type: AIF_PMS_UPDATE,
            payload: { watchlist: data, totalPages: totalPages },
        });
    };
    AifPmsActions.prototype.updateMsg = function (message) {
        this.dispatch({
            type: AIF_PMS_UPDATE_MSG,
            payload: { message: message },
        });
    };
    AifPmsActions.prototype.clearMsg = function () {
        this.dispatch({
            type: AIF_PMS_CLEAR_MSG,
        });
    };
    AifPmsActions.prototype.updateSortedData = function (pmsFundsSchemes) {
        this.dispatch({
            type: AIF_PMS_UPDATE_SORTED_DATA,
            payload: { pmsFundsSchemes: pmsFundsSchemes },
        });
    };
    AifPmsActions.prototype.applySearching = function (searchData, updateData) {
        this.dispatch({
            type: AIF_PMS_UPDATE_SEARCH_DATA,
            payload: { searchState: searchData, updatedData: updateData },
        });
    };
    AifPmsActions.prototype.updateMutualFundsParams = function (paramsData) {
        this.dispatch({
            type: AIF_PMS_PARAMS,
            payload: { paramsData: paramsData },
        });
    };
    AifPmsActions.prototype.applySorting = function (sortData, updateData) {
        this.dispatch({
            type: AIF_PMS_APPLY_SORT,
            payload: {
                sortState: sortData,
                updatedData: JSON.parse(JSON.stringify(updateData)),
            },
        });
    };
    AifPmsActions.prototype.clearSorting = function () {
        this.dispatch({
            type: AIF_PMS_CLEAR_SORT,
        });
    };
    AifPmsActions.prototype.clearSearching = function () {
        this.dispatch({
            type: AIF_PMS_CLEAR_SEARCH_DATA,
        });
    };
    AifPmsActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: AIF_PMS_ERROR,
            payload: { errorData: payload },
        });
    };
    AifPmsActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: AIF_PMS_HIDE_ERROR,
        });
    };
    AifPmsActions.prototype.updateWatchListData = function (req) {
        this.dispatch({
            type: UPDATE_WATCHLIST_DATA,
            payload: {
                watchListData: req,
            },
        });
    };
    AifPmsActions.prototype.updateSubCategoryId = function (req) {
        this.dispatch({
            type: UPDATE_SUB_CATEGORY_ID,
            payload: {
                subCategoryId: req,
            },
        });
    };
    AifPmsActions.prototype.updateSubCategoryPmsId = function (req) {
        this.dispatch({
            type: UPDATE_SUB_CATEGORY_PMS_ID,
            payload: {
                subCategoryPmsId: req,
            },
        });
    };
    AifPmsActions.prototype.bookmark = function (req) {
        throw new Error("Method not implemented.");
    };
    AifPmsActions.prototype.bookmarkWatchlist = function (req) {
        this.dispatch({
            type: UPDATE_BOOKMARK_WATCHLIST,
            payload: {
                bookmarkWatchlist: req,
            },
        });
    };
    AifPmsActions.prototype.saveDraftDocs = function (req) {
        this.dispatch({
            type: UPDATE_SAVE_DRAFT_DOCS,
            payload: {},
        });
    };
    AifPmsActions.prototype.draftOrderUpdate = function (req) {
        //
    };
    AifPmsActions.prototype.deletedDraftDocs = function (req) {
        this.dispatch({
            type: UPDATE_DELTED_DRAFT_DOCS,
            payload: {},
        });
    };
    AifPmsActions.prototype.updateClientDetails = function (req) {
        this.dispatch({
            type: UPDATE_CLIENT_DETAILS,
            payload: {
                clientDetails: req,
            },
        });
    };
    AifPmsActions.prototype.multiBookmark = function (req) {
        this.dispatch({
            type: UPDATE_MULTI_BOOKMARK,
            payload: {
                multiBookmark: req,
            },
        });
    };
    AifPmsActions.prototype.updateTransactionId = function (req) {
        this.dispatch({
            type: UPDATE_TRANS_ID,
            payload: {
                transactionId: req,
            },
        });
    };
    AifPmsActions.prototype.commonBankMaster = function (response) {
        this.dispatch({
            type: UPDATE_COMMON_BANK_MASTER,
            payload: {
                commonbankMaster: response,
            },
        });
    };
    return AifPmsActions;
}());
export default AifPmsActions;
